import * as React from 'react'
import { observer } from 'mobx-react'
import cx from 'classnames'
import styles from './JobListEmpty.sass'
import { JobListViewModel } from '../JobListViewModel'
import link from 'infra/link'
import { Link } from 'react-router-dom'
import { useBrandingSettings } from 'hooks/branding'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  vm: JobListViewModel
}

export default observer(function JobListEmpty({ vm }: Props) {
  const wasSearching = vm.searcher.lastSearch.filtersApplied
  const { corporateMode } = useBrandingSettings()
  return (
    <div className={cx(styles.root)}>
      {!corporateMode && (
        <div className={styles.illustration}>
          <img
            src={require(
              wasSearching
                ? 'assets/images/img_search-noresults.svg'
                : 'assets/images/img_no-jobs.svg',
            )}
            alt=""
          />
        </div>
      )}
      <h2 className={styles.title}>
        {wasSearching ? <>We looked everywhere...</> : <>No active jobs.</>}
      </h2>
      <p className={styles.description}>
        {wasSearching ? (
          <>But we couldn't find any active jobs matching your search.</>
        ) : !wasSearching && vm.canViewOpportunities ? (
          <>
            Ready for more? Head on over to{' '}
            <Link className={styles.link} to={link.opportunities()}>
              opportunities
            </Link>{' '}
            and see what's available!
          </>
        ) : (
          <>Active jobs will be shown here!</>
        )}
      </p>
    </div>
  )
})
